﻿import $ from "jquery";
import { endsWith } from "./typescript/Vgr.Util.ts";

$.widget("hittaSearch.SearchPage", {
  // Default options.
  options: {},

  _init: function () {
    //  this._filterOptionChanged();

    this._filterOptionReset();

    this._addClassToSelectOption();

    this._showResetButton();

    this._trackEvent();

    this._trackClickUrl();
  },

  _addClassToSelectOption: function () {
    // Add a class to each select option so that we can track user clicks
    $(".wrapper")
      .find(".select > option")
      .each(function () {
        // Class name will be the same as the elements value attribute.
        // Replace all dots with dashes since it a class name
        var dummyClass = $(this).val().split(".").join("-");

        if (dummyClass) $(this).addClass(dummyClass);
      });
  },

  _filterOptionReset: function () {
    var self = this;
    $(".reset").click(function () {
      // Select all filter options and reset their values
      $(".select", self.element).val("");

      // $(this)._submitForm();
      //this.submitForm();
      var $form = $("#search-form");
      $form.submit();
    });
  },

  _showResetButton: function () {
    $(".reset").removeClass("hidden");
  },

  _submitForm: function () {
    // The form
    var $form = $("#search-form");

    // Submit it
    $form.submit();
  },
  // Tracks using Piwik events
  _trackEvent: function () {
    var _paq = (window._paq = window._paq || []);

    $("#widen-search").click(function () {
      var scope = $("#search-form #Scope").val();
      if (_paq) {
        _paq.push([
          "trackEvent",
          "Hitta händelselogg",
          "Klick ur scope",
          "Scope: " + scope,
        ]);
      }
    });

    $("#did-you-mean").click(function () {
      var linkText = $(this).text();
      if (_paq) {
        _paq.push([
          "trackEvent",
          "Hitta händelselogg",
          "Klick på ord förslag",
          "Förslag: " + linkText,
        ]);
      }
    });
  },

  //Track clicks on search results for persons
  _trackClickUrl: function () {
    var self = this;
    // Track when the search card is expanded
    $(".vgr-search-card__expand-button").click(function () {
      // We should not register a click when the search card is already expanded.
      if ($(this).closest(".vgr-toggle").attr("data-isexpanded") === "true") {
        return;
      }

      var $searchCard = $(this).closest(".vgr-search-card--person");
      if (!$searchCard || $searchCard.length < 1) {
        return;
      }

      // Find the click-url
      var $clickUrlEl = $searchCard.find("[data-clickurl]");
      if (!$clickUrlEl || $clickUrlEl.length < 1) {
        return;
      }

      var clickUrl = $clickUrlEl.attr("data-clickurl");

      self._sendRequestToClickUrl(clickUrl);
    });

    // Track if the headline is clicked
    $(".person-headline-link").click(function () {
      // Find the click-url
      var clickUrl = $(this).attr("data-clickurl");
      self._sendRequestToClickUrl(clickUrl);
    });
    $(".vgr-search-card__headline__link").click(function () {
      // Find the click-url
      var clickUrl = $(this).attr("data-clickurl");
      self._sendRequestToClickUrl(clickUrl);
    });
  },
  _sendRequestToClickUrl: function (clickUrl) {
    var urlRightPart = location.pathname;
    // Append a slash if it's missing
    if (!endsWith(urlRightPart, "/")) {
      urlRightPart += "/";
    }

    // Call backend to execute the tracking.
    // This needs to be done in backend as the persons-searcher isn't exposed externally
    $.ajax({
      url: urlRightPart + "TrackClickUrl",
      method: "POST",
      data: { clickUrl: clickUrl },
    }).done(function (result) {});
  },
});

(function ($, hittaSearch) {
  // Select all drop down listboxes containing filtering options
  var $searchPage = $("#search-page");
  if ($searchPage.length > 0) {
    // Execute widget
    $searchPage.SearchPage();
  }
})($);
